export interface PageAnalyticsContext {
  page_type: string;
  route_template: string;
  entity_type?: string;
  search_mode?: string;
}

export function getPageAnalyticsContext(pathname: string, search = ''): PageAnalyticsContext {
  const segments = pathname.split('/').filter(Boolean);
  const params = new URLSearchParams(search);

  if (pathname === '/') return { page_type: 'home', route_template: '/' };
  if (pathname === '/browse') {
    const searchMode = params.has('search')
      ? 'semantic'
      : params.get('geoCity') === '1'
        ? 'geo_city'
        : params.has('eventType')
          ? 'category'
          : 'browse';
    return { page_type: 'event_search', route_template: '/browse', search_mode: searchMode };
  }
  if (pathname === '/map') return { page_type: 'event_map', route_template: '/map' };
  if (pathname === '/categories') return { page_type: 'event_categories', route_template: '/categories' };
  if (segments[0] === 'event' && segments.length >= 2) {
    return { page_type: 'event_detail', route_template: '/event/:eventId/:eventSlug' };
  }
  if (segments[0] === 'location' && segments[2] === 'events') {
    return { page_type: 'location_events', route_template: '/location/:locationSlug/events' };
  }
  if ((segments[0] === 'partner' || segments[0] === 'company') && segments[2] === 'events') {
    return {
      page_type: 'entity_events',
      route_template: '/:entityType/:entitySlug/events',
      entity_type: segments[0],
    };
  }
  if (segments[0] === 'group' && segments.length >= 2) {
    return { page_type: 'event_group', route_template: '/group/:groupSlug' };
  }
  if (pathname === '/groups/new') return { page_type: 'event_group_create', route_template: '/groups/new' };
  if (segments[0] === 'admin') return { page_type: 'admin', route_template: '/admin/*' };
  if (pathname === '/how-it-works' || pathname === '/latest-updates') {
    return { page_type: 'editorial', route_template: pathname };
  }
  return { page_type: 'other', route_template: pathname };
}